<template>
  <div class="orderDetails">
    <!-- <div class="nav-bar">
      <van-nav-bar title="停车缴费" left-text="返回" left-arrow @click-left="onClickLeft"></van-nav-bar>
    </div> -->
    <div class="advertising" style="margin: 2% 0px;" v-if="url!=''">
      <img :src="url" @click="clickUrl()" width="100%" height="100%" />
    </div>
    <p class="car-num">车牌号:{{carNum}}</p>
    <div class="order-info">
      <van-cell-group style="border-bottom: 1px solid rgba(204, 204, 204, 1);;">
        <van-cell class="should-pay" title="停车费用"    :value="'￥'+orderDetails.shouldPay"/>
        <van-cell title="已缴费"      :value="'￥'+orderDetails.alreadyPay" />
        <van-cell title="停车时长"    :value="orderDetails.parkingTime" />
        <van-cell title="停车场名称"  :value="orderDetails.parkName" />
        <van-cell title="入场时间"    :value="orderDetails.startTime" />
        <van-cell title="优惠卷"      is-link :value="couponStr" @click="showCouponPopup" />
        <van-cell v-if="payChanel==8" title="支付方式" is-link :value="payWayStr" @click="showPopup" :label="'余额：￥'+userAccount.balanceRecharge" />
        <van-cell v-if="payChanel==14" title="支付方式" is-link :value="payWayStr" @click="showPopup" />
      </van-cell-group>
    </div>
    <template v-if="couponStr=='选择'">
      <van-button v-if="payBtShow&&orderDetails.needPay>0" class="bt-qurey" color="#f47b20" @click="pay">缴费￥{{orderDetails.needPay}}元</van-button>
    </template>
    <template  v-if="couponStr!='选择'">
      <van-button v-if="payBtShow" class="bt-qurey" color="#f47b20" @click="pay">缴费￥{{orderDetails.needPay}}元</van-button>
    </template>
    <van-button v-if="notPayBtShow" class="bt-qurey" color="#aaaaaa">该停车场不支持线上缴费</van-button>

    <van-popup class="pay-popup" v-model="show" position="bottom">
      <van-radio-group v-model="payChanel" v-if="payWayList.length>0">
        <van-cell-group v-for="item in payWayList" :key="item.value">
          <van-cell v-if="(item.name == '余额支付' && userAccount.balanceRecharge!=-1) || item.name !='余额支付'" :title="item.name" :icon="item.icon" clickable @click="changePayWay(item.value)">
            <template #right-icon>
              <van-radio :name="item.value" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>
    <van-popup class="loading-popup" v-model="IsLoading">
      <van-loading  size="24px" color="#FFF" vertical>余额支付</van-loading>
    </van-popup>
    <van-popup class="coupon-popup" position="bottom" v-model="couponShow">
      <UseableCoupon @event1="changeNeedpay($event)" v-if="couponShow" :orderId="orderDetails.orderId" :userId="userId" :needPay="original"  :companyId="orderDetails.companyId" :payScene="payScene"></UseableCoupon>
    </van-popup>

  </div>
</template>

<script>
import { mySessionStorage } from '@/utils/storage.js'
import UseableCoupon from '@/components/coupon/useableCoupon';
export default {
  components: {
    UseableCoupon
  },
  name: "orderDetails",
  data() {
    return {
      url: "", //展示图片
      cUrl: "", //点击跳转地址
      title: "",
      active: "2",
      carNum: "",
      openid:"",
      userId:"",
      couponShow:false,
      userAccount:{balanceRecharge:-1},
      show:false,
      payBtShow:true,
      notPayBtShow:false,
      payChanel:"14",
      payWayStr:"微信支付",
      companyId:"",
      adsence:{},
      payWayList:[],
      adsenceImgUrl:"../static/img/adsence4.jpg",
      IsLoading:false,
      payLevel:0,
      orderDetails:{
        shouldPay:"",
        needPay:"",
        parkingTime:"",
        startTime:"",
        parkName:"",
        orderId:"",
        type:"",
        carNum:"",
        companyId:""
      },
      //原价
      original:"",
      payScene:"roadEscapeRange",
      couponStr:"选择"

    };
  },
  methods: {
    onClickLeft() {
      console.log("返回");
      this.$router.push("/menu");
    },
    changeNeedpay(data){
      console.log("子组件传来的值",data)
     this.orderDetails.needPay=data.needpayNew;
     this.couponStr=data.couponStr;
     this.couponShow=false;
    },
    //清除优惠券缓存
    clearCouponCache(orderId){
      let params={
        orderId:orderId
      }
      this.$http
        .post(this.$api.clearCouponCache, params)
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //发起支付
    pay() {
		let needPay = this.orderDetails.needPay;
      console.log(this.payChanel);
      if (this.payChanel == '8') {
        if (this.userAccount.balanceRecharge < needPay) {
          this.$toast("余额不足");
          return;
        }
        this.IsLoading=true;
      }
      let params = {
        carNum: this.carNum,
        orderId: this.orderDetails.orderId,
        payWay: 2, //微信或小程序支付
        payChanel: this.payChanel, //[8:余额支付；14:w微信支付]
        payLevel: this.payLevel,
        openid: this.openid,
        payMoney: needPay,
        type: this.orderDetails.type
      };
      console.log(JSON.stringify(params));

      this.$http
        .post(this.$api.wxPubPay, params)
        .then(res => {
          if (res.code == 200) {
            switch (this.payChanel) {
              case "8"://余额支付
                this.IsLoading=false
                this.goPayResult(1);
                break;
              case "14"://微信支付
                var opthions = JSON.parse(res.data);
                console.log(opthions);
                this.$WXjsSDK(opthions,"缴费成功，请尽快离场","pay",needPay);
               break;
            }
          }
          else {
            switch (this.payChanel) {
              case "8"://余额支付
                this.IsLoading=false
                this.goPayResult(0);
                break;
              case "14"://微信支付
                this.$toast("发起支付失败，请稍后再试");
                break;
            }

          }

        })
        .catch(err => {
          switch (this.payChanel) {
              case "8"://余额支付
                this.IsLoading=false
                this.goPayResult(0);
                break;
              case "14"://微信支付
                this.$toast("发起支付失败，请稍后再试");
                break;
            }
        });

    },
    //获取上个页面传来订单详细信息
    getOrderDetails(){
      this.orderDetails.shouldPay=this.$route.query.shouldPay;
      this.orderDetails.needPay=this.$route.query.needPay;
      this.orderDetails.parkingTime=this.$route.query.parkingTime;
      this.orderDetails.startTime=this.$route.query.startTime;
      this.orderDetails.parkName=this.$route.query.parkName;
      this.orderDetails.orderId=this.$route.query.orderId;
      this.orderDetails.type=this.$route.query.type;
      this.orderDetails.companyId=this.$route.query.companyId;
      this.orderDetails.carNum=this.$route.query.carNum;
      this.companyId=this.orderDetails.companyId;
      this.carNum=this.orderDetails.carNum;
      this.payLevel=this.$route.query.payLevel;
      this.orderDetails.alreadyPay=(this.orderDetails.shouldPay-this.orderDetails.needPay).toFixed(2);
      if(this.payLevel==0){
        this.queryBycarNum();
      }
      this.original=this.orderDetails.needPay
      console.log(this.orderDetails);
      this.getUserBalance();
      this.clearCouponCache(this.orderDetails.orderId);
    },
    //根据车牌号重新获取订单信息
    queryBycarNum() {
      let params = {
        carNum: this.carNum
      };
      console.log(this.carNum);
      this.$http
        .post(this.$api.queryWechatOrder, params)
        .then(data => {
          if (data.code == 200) {
            this.orderDetails.shouldPay=data.data.shouldPay;
            this.orderDetails.needPay=data.data.needPay;
            this.orderDetails.parkingTime=data.data.parkingTime;
            this.orderDetails.startTime=data.data.order.startTime;
            this.orderDetails.parkName=data.data.order.parkName;
            this.orderDetails.orderId=data.data.order.id;
            this.orderDetails.type=data.data.type;
            this.orderDetails.companyId=data.data.order.companyId;
            this.orderDetails.carNum=this.carNum;
          }
          else{
            this.$toast.fail("暂无在停订单");
          }
        })
        .catch(err => {
          console.log(err);
           this.$toast.fail("暂无在停订单");
        });
    },
    showPopup() {
      this.show = true;
    },
    //切换支付方式
    changePayWay(type){
      this.payChanel=type+"";
      if(type==8){
        this.payWayStr='余额支付';
        if(this.userAccount.balanceRecharge<this.orderDetails.needPay){
          this.$toast("余额不足");
          return;
        }
      }
      if(type==14){
        this.payWayStr='微信支付';
      }
     this.show=false;
    },
    //获取该订单停车场支持的线上缴费方式
    getSupportPayWay() {
      let params = {
        companyId: this.companyId,
      };
      this.$http
        .post(this.$api.getpayWayList, params)
        .then(res => {
          console.log("缴费方式:", res);
          if (res.code == 200) {
            this.payWayList=res.data;
            if (this.payWayList.length == 0) {
              this.payBtShow = false;
              this.notPayBtShow = true;

            }
            if (this.payWayList.length == 1){
               this.payChanel=this.payWayList[0].value;
               this.payWayStr=this.payWayList[0].name;
            }
          }
          else{
            this.payBtShow = false;
            this.notPayBtShow = true;
          }
        })
        .catch(err => {
          console.log(err);
          this.payBtShow = false;
          this.notPayBtShow = true;

        });
    },
    //
    showCouponPopup(){
      this.couponShow=true;
    },
    getUserId() {
        this.$http.post(this.$api.myWallet + "/" + this.openid, {}).then(res => {
          this.userId = res.data.appUserId;
        });
    },
    //获取用户余额
    getUserBalance() {
      let params = {
        openid: this.openid,
      };
      this.$http
        .post(this.$api.getUserBalance, params)
        .then(res => {
          console.log("余额信息:", res);
          if (res.code == 200) {
            this.userAccount=res.data;
            if(this.userAccount.balanceRecharge>this.orderDetails.needPay){
              this.payChanel="8";
              this.payWayStr="余额支付";
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //跳转到支付结果页
    goPayResult(result){
      this.$router.push(
        {
          name:"payResult",
          query:{
            result:result,
            msg:"缴费成功，请尽快离场"
          }
        }
        );
    },
    //广告加载
    getAdvertisingInfo() {
      this.$axios({url: this.$api.payDetails,method: "get",})
        .then(res => {
          this.url = res.data.data.creativeImg.creativeUrl;
          this.cUrl = res.data.data.landingPage;
          let trackUrl = res.data.data.trackUrl;
          this.$axios({
            url: trackUrl,
            method: "get",
          }).then(res => {
            console.log(res)
          });
          console.log(res.data);
        })
    },
    clickUrl() {
      window.location.href = this.cUrl;
    }

  },
  created() {
   //this.getAdsense();
  },
  mounted(){
    //mySessionStorage.setItem("openid", "o1KC-wsvSK2iAGTF0V-v0iRUmdw0");
    this.openid=mySessionStorage.getItem("openid");
    this.getOrderDetails();
    console.log("orderDetails---openid",this.openid);
    this.getSupportPayWay();
    this.getAdvertisingInfo();
    this.getUserId();
    
  },
};
</script>

<style scoped>
.orderDetails {
  min-height: 100%;
  height: 100%;
  width: 100%;
  max-width: 100%;
  background-color: #e8e9eb;
  float: left;
  overflow: scroll;
  height: calc(100vh);
}
.adsense-space{
  width: 100%;
  height: 25%;
  /* margin-left: 2%; */
  border-radius: 8px;
}
.adsense-space img{
    height: 100%;
    width: 100%;
    border-radius: 8px;
}
.nav-bar {
  width: 100%;
  height: 46px;
  float: left;
}
.car-num-holder {
  height: 40px;
  width: 100%;
  float: left;
}
.car-num{
    text-align: center;
    background-color: #FFFFFF;
    width: 100%;
    margin: 0 ;
    /* margin: 0; */
    padding: 0;
    height: 40px;
    line-height: 40px;
}
.order-info{
  width: 100%;
  /* margin-left: 2%; */
  border-radius: 8px;

}
.bt-qurey {
  width: 80%;
  margin-left: 10%;
  margin-top: 30px;
  border-radius: 5px;
  height: 36px;
  /* position: fixed;
  display: block; */
}

.pay-popup{
    width: 100%;
    height: 20%;
}
.loading-popup{
  height: 75px;
  width: 100px;
  padding-top: 25px;
  border-radius: 10px;
  background-color: #333;
}
.van-icon-wechat::before{
    color: green;
}
.van-icon-balance-o::before{
    color: #f47b20;
}
.van-cell{
  border-top: 1px solid rgba(204, 204, 204, 1);;
    border-left: 1px solid rgba(255, 255, 255, 1);
    border-right: 1px solid rgba(255, 255, 255, 1);
}
.van-cell{
  color:  #666;
}
.should-pay .van-cell__value{
  color: red;
  font-size: 18px;
}
.van-cell__value{
  color:  #333;
}
.coupon-popup{
  height: 90%;
  width: 100%;
  border-radius: 8px 8px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/order/orderDetails.vue